import { AlertActionTypes } from 'util/modules/Alert/redux/types'
/**
* Data Types
*/

export interface OrderStatus {
  id: number,
  order: number,
  color: string,
  name: string,
  alias: string,
  staffMessage: string,
  clientMessage: string,
  icon: string,
  roles: ('OWNER'|'MANAGER'|'DELIVERYMAN'|'COOKER'|'CLERK')[],
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface OrderStatusState {
  readonly orderStatus?: OrderStatus
  readonly orderStatusList: OrderStatus[]
}

/**
* Action Enum Types
*/

export enum OrderStatusTypes {
  ORDER_STATUS_CREATE = 'ORDER_STATUS/CREATE',
  ORDER_STATUS_UPDATE = 'ORDER_STATUS/UPDATE',
  ORDER_STATUS_DELETE = 'ORDER_STATUS/DELETE',
  ORDER_STATUS_GET = 'ORDER_STATUS/GET',
  ORDER_STATUS_GET_LIST = 'ORDER_STATUS/GET/LIST',
}

/**
* Action Types
*/
interface CreateAction {
  type: typeof OrderStatusTypes.ORDER_STATUS_CREATE,
  payload: OrderStatus
}

interface UpdatetAction {
  type: typeof OrderStatusTypes.ORDER_STATUS_UPDATE,
  payload: OrderStatus
}

interface DeleteAction {
  type: typeof OrderStatusTypes.ORDER_STATUS_DELETE,
  payload: number
}

interface GetAction {
  type: typeof OrderStatusTypes.ORDER_STATUS_GET,
  payload: OrderStatus
}

interface GetListAction {
  type: typeof OrderStatusTypes.ORDER_STATUS_GET_LIST,
  payload: OrderStatus[]
}

export type OrderStatusActionTypes = (
  AlertActionTypes | CreateAction | UpdatetAction | DeleteAction | GetAction | GetListAction
)
